export const SUPER_ADMIN_FORM = [
  {
    name: "name",
    type: "text",
    placeholder: "Name",
    label: "Name :",
    required: true,
  },
  {
    name: "username",
    type: "text",
    placeholder: "User Name",
    label: "User Name :",
    required: true,
  },
  {
    name: "password",
    type: "password",
    placeholder: "Password",
    label: "Password :",
    required: true,
  },
  {
    name: "contactInfo.phone",
    type: "text",
    placeholder: "Phone Number",
    label: "Phone Number:",
    required: true,
  },
  {
    name: "contactInfo.email",
    type: "email",
    placeholder: "Email Address",
    label: "Email:",
    required: true,
  },
];
